export class AdditionalPrice {
    public oid?: number;
    public baseAmount: number;
    public additionalOid?:number;
    public included?:boolean;
    public posOid?:number;

    constructor(obj?: AdditionalPrice){
        if(!obj) {
            return {
                baseAmount:0,
            };
        }else{
            return obj;
        }
    };
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/additional/additional-price.ts